import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { NewSelectionList } from './NewSelectionList';
import { useTranslation } from 'react-i18next';

/**
 * Props for <NewSelectionListDropdown>.
 */
interface Props {
    /**
     * Creates a new selection list with the given name.
     */
    readonly onCreateSelectionList: (name: string) => void;
}

export const NewSelectionListDropdown: FC<Props> = ({ onCreateSelectionList }) => {
    const { t } = useTranslation();
    const [showDropdown, setShowDropdown] = useState(false);

    const btnRef = useRef<HTMLDivElement>(null);
    const inputRef = useRef<HTMLInputElement>(null);

    const toggleDropdown = useCallback(() => setShowDropdown(it => !it), []);

    useEffect(() => {
        if (showDropdown) {
            inputRef.current?.focus();
        }
    }, [showDropdown, inputRef]);

    return (
        <>
            <div ref={btnRef} className="bt-line">
                <div className="default-dd-nav bt-bordered add-to-list dd-medium" style={{ marginBottom: '5px' }}>
                    <a className="bt-dd" onClick={toggleDropdown}>
                        <span className="bt-inner truncate">
                            <i className="material-icons fl-left normal">add</i>
                            <span>{t('selectionList.newSelection')}</span>
                        </span>
                    </a>
                </div>
            </div>

            {showDropdown ? (
                <div className="selection-list-dropdown default-dd-nav dd-w-select bt-bordered add-to-list dd-medium absolute-position">
                    <div className="default-dd">
                        <NewSelectionList onCreateSelectionList={onCreateSelectionList} ref={inputRef} />
                    </div>
                </div>
            ) : null}
        </>
    );
};
